/**
 * Vercel Web Analytics
 *
 * Cookieless visitor analytics for the PUBLIC marketing pages. Unlike
 * PostHog (see `@/lib/posthog`), this sets no cookies and stores no
 * personal data, so it needs no consent banner — which is the point:
 * PostHog only starts after a visitor clicks "Accept", so it can never
 * tell us how many people actually landed on the site.
 *
 * Production only. Local dev would otherwise load Vercel's debug script
 * from va.vercel-scripts.com, which the CSP in index.html blocks, and
 * dev page views are not visitor data anyway.
 */

import { Analytics } from '@vercel/analytics/react'
import { beforeSend } from '@/lib/web-analytics'

export function WebAnalytics() {
  if (!import.meta.env.PROD) return null
  return <Analytics beforeSend={beforeSend} />
}
